import initI18n from './i18n';

export default function init() {
  initI18n();
}
